import { render, staticRenderFns } from "./ScraperSingle.vue?vue&type=template&id=61894ace&"
import script from "./ScraperSingle.vue?vue&type=script&lang=js&"
export * from "./ScraperSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports